#import "../../../../../email-marketing/graphql-wrappers/drip-sequence/graphql/fragments/drip-sequence-fragment.graphql"

mutation FilteredListAddToDripSequence($input: FilteredListAddToDripSequenceInput!) {
    filteredListAddToDripSequence(input: $input) {
        dripSequence {
            ...DripSequenceFragment
        }
    }
}
